import * as SignalR from '@aspnet/signalr';
import { actionTypes } from 'src/reducers/Layout';
import { Dispatch } from 'redux';

export default class SignalRHandler {
    // to dispatch in below code, do this
    // SignalRHandler.dispatch(actionCreators.showGlobalSearch());
    static dispatch: Dispatch;

    static initialize = (dispatch: Dispatch) => {
        SignalRHandler.dispatch = dispatch;
    };

    static Configure(connectionUrl: string, jwt: string) {
        console.log('SignalR Configure URL:', connectionUrl);
        const messagingConnection = new SignalR.HubConnectionBuilder().withUrl(connectionUrl, { accessTokenFactory: () => jwt }).build();
        const baseUrl = process.env.REACT_APP_BASE_API_URL;

        messagingConnection.stop();

        // @aspnet/signalr has no withAutomaticReconnect() (that landed later, in @microsoft/signalr),
        // so a dropped connection needs to be retried manually or completion notifications for the
        // rest of the session are lost - there's no polling fallback, SignalR is the only signal.
        let reconnectAttempts = 0;
        const scheduleReconnect = () => {
            const delay = Math.min(30000, 1000 * Math.pow(2, reconnectAttempts));
            reconnectAttempts++;
            setTimeout(() => {
                messagingConnection.start()
                    .then(() => {
                        console.log('SignalR reconnected.');
                        reconnectAttempts = 0;
                    })
                    .catch((err) => {
                        console.log('SignalR reconnect failed:', err);
                        scheduleReconnect();
                    });
            }, delay);
        };

        messagingConnection.on('send', (data) => {
            console.log(data);
        });

        messagingConnection.on('sendForDownload', async (s3FileId: number, reportTitle: string, message: string) => {
            window.alert(message);

            const a = document.createElement('a');
            a.style.display = 'hidden';
            a.id = 'reportServerDownload';

            await fetch(`${baseUrl}/v1.0/s3Bucket/by-id/${s3FileId}`).then(async (response) => {
                if (response.ok) {
                    await response.blob().then(blob => {
                        if (blob.size > 0) {
                            const blobUrl = window.URL.createObjectURL(blob);
                            a.href = blobUrl;
                            a.download = reportTitle ? `${reportTitle}.xlsx` : 'report.xlsx';
                            a.click();
                            window.URL.revokeObjectURL(blobUrl);
                        }
                    });
                }
            }).catch((error) => {
                console.log('Error fetching s3File: ', error);
            });
        });

        messagingConnection.on('sendError', (message: string) => {
            console.log('ERROR: task failed - ', message);
            window.alert(message);
        });

        messagingConnection.on('AssignTask', (data) => {
            console.log(data);
        });

        messagingConnection.on('testSignal', (data) => {
            console.log('Signal Command:', data);
            window.alert('Test successful! Check Console!');
        });

        messagingConnection.onclose(() => {
            console.log('SignalR connection closed - attempting to reconnect.');
            scheduleReconnect();
        });

        messagingConnection.on('InvoiceGenerationComplete', (message: string) => {
            SignalRHandler.dispatch({
                type: actionTypes.SET_GENERATING_INVOICES,
                payload: false
            });
            window.alert('Invoices generated!' + ' ' + message);
        });

        messagingConnection.on('DocumentGenerationComplete', (message: string) => {
            SignalRHandler.dispatch({
                type: actionTypes.SET_GENERATING_DOCUMENTS,
                payload: false
            });
            window.alert('Documents generated!' + ' ' + message);
        });

        messagingConnection.on('InvoiceGenerationFailed', (message: string) => {
            SignalRHandler.dispatch({
                type: actionTypes.SET_GENERATING_INVOICES,
                payload: false
            });
            window.alert('Invoice generation failed: ' + message);
        });

        messagingConnection.on('DocumentGenerationFailed', (message: string) => {
            SignalRHandler.dispatch({
                type: actionTypes.SET_GENERATING_DOCUMENTS,
                payload: false
            });
            window.alert('Document generation failed: ' + message);
        });

        messagingConnection.on('ZipGenerationComplete', (presignedUrl: string, fileName: string, message: string) => {
            SignalRHandler.dispatch({ type: actionTypes.SET_GENERATING_ZIP, payload: false });
            window.alert(message);
            const a = document.createElement('a');
            a.href = presignedUrl;
            a.download = fileName;
            a.click();
        });

        messagingConnection.on('ZipGenerationFailed', (message: string) => {
            SignalRHandler.dispatch({ type: actionTypes.SET_GENERATING_ZIP, payload: false });
            window.alert('Zip archive generation failed: ' + message);
        });

        messagingConnection.start()
            .then(() => console.log('SignalR connection established.'))
            .catch((err) => {
                console.log('Signal connection error:', err);
                scheduleReconnect();
            });
    }
}



// WEBPACK FOOTER //
// ./src/messaging/SignalRHandler.ts